import { BaseModel } from '~/models/baseModel';

export class CustomHeaderPageModel extends BaseModel {
    public id:string;
    public heading:string;
    public summary:string;
}
